export default "__VITE_ASSET__D87fr5mm__"